import { Button } from '@/components/ui/button'
import { useToast } from '@/components/ui/use-toast'
import { MagicWandIcon, PlusIcon, UpdateIcon } from '@radix-ui/react-icons'
import { postFetcher } from 'api/swr'
import React from 'react'
import { useParams } from 'react-router-dom'
import { mutate } from 'swr'
import useSWRMutation from 'swr/mutation'

const DataTableToolbar = ({ tonings }) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center text-sm text-muted-foreground">
        <MagicWandIcon className="mr-2 h-4 w-4" /> {tonings?.length}
      </div>
      <CreateButton />
    </div>
  )
}

const CreateButton = () => {
  const { tid } = useParams()
  const { toast } = useToast()
  const { trigger, isMutating } = useSWRMutation('/tonings', postFetcher, {
    onSuccess: () => {
      mutate(['/tonings', { tid }])
      toast({
        title: 'Toning Created',
        description: 'The toning has been successfully created.',
        className: 'bg-green-500 text-white',
      })
    },
  })

  const handleClick = () => {
    trigger({ tid })
  }
  return (
    <Button
      variant="outline"
      className="ml-auto"
      disabled={isMutating}
      onClick={handleClick}
    >
      {isMutating ? (
        <>
          <UpdateIcon className="mr-2 h-4 w-4 animate-spin" /> Creating...
        </>
      ) : (
        <>
          <PlusIcon className="mr-2 h-4 w-4" /> Create toning
        </>
      )}
    </Button>
  )
}

export default DataTableToolbar
